module.exports = __webpack_public_path__ + "img/account-icon-03.2345b027.svg";